import { localStorageHelper } from '@umu/umu-storage';

export enum PLATFORM_TYPE {
    USE = 'use',
    LEARNING = 'learning',
}

const CACHE_KEY = 'current_platform_name';

export const platformCache = {
    setPlatform(platform: PLATFORM_TYPE) {
        localStorageHelper.set(CACHE_KEY, platform);
    },
    getPlatform() {
        return localStorageHelper.get(CACHE_KEY) as PLATFORM_TYPE;
    },
};
